<template>
      <div class="customer">
         <tab-bar :tabs="tabs"></tab-bar>
         <router-view></router-view>
     </div>
 </template>


 <script type="text/javascript">
 import { mapState } from 'vuex';
 import TabBar from '../TabBar';
 import store from '../../store.js';

 export default {
  data () {
    return {
      tabs: {}
    };
  },
  computed: mapState({
    indicators: state => state.indicators,
  }),
  components: {
    TabBar
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchSelectedIndicator', { id: to.params.id });
    next();
  }
 };

 </script>
 <style lang="scss" scoped>

 </style>



// WEBPACK FOOTER //
// src/components/indicators/Indicator.vue